import './App.css';
import { Linkedin } from 'react-feather';
import Microlink from '@microlink/react';

/* =========================
   DATA
========================= */

const NEWS_LINKS = [
  // "https://media.un.org/photo/en/asset/oun7/oun758620?utm_source=perplexity",
  "https://www.tribuneindia.com/2014/20140603/j&k.htm",
  // "https://economictimes.indiatimes.com/news/politics-and-nation/81-per-cent-power-supply-restored-in-kashmir-jammu-and-kashmir-government/articleshow/43236925.cms?from=mdr",
  "https://www.pib.gov.in/newsite/PrintRelease.aspx?relid=145435&reg=3&lang=2",
  // "https://www.dailyexcelsior.com/86000-projects-taken-up-on-single-tender-during-2010-19-in-jsd-transparency-restored-thereafter/",
  "https://www.linkedin.com/posts/arun-kumar-mehta-182175b6_baramulla-jammu-kashmir-three-decades-activity-7333465226681454593-HavY/",
  "https://www.news18.com/india/no-scope-of-corruption-in-j-k-now-as-all-services-made-online-chief-secretary-8563185.html",
  "https://www.kashmirnewsobserver.com/top-stories/tribunal-throws-out-ashok-parmar-s-petition-against-lg-senior-bureaucrats-kno-186976",
  // "https://www.linkedin.com/posts/arun-kumar-mehta-182175b6_86000-projects-taken-up-on-single-tender-activity-7321058160985657344-vC54/",
  "https://www.tribuneindia.com/news/j-k/house-panel-formed-to-investigate-irregularities-in-jal-jeevan-mission/",
  "https://timesofindia.indiatimes.com/india/arun-kumar-mehta-is-jks-new-chief-secretary/articleshow/83014498.cms",
  "https://www.earlytimes.in/newsdet.aspx?q=316939",
  "https://www.newindianexpress.com/nation/2023/Nov/01/srinagar-diary-after-dgp-jk-to-get-new-chief-secretary-2628913.html",
  "https://www.news18.com/news/india/jk-govt-appoints-ias-officer-arun-kumar-mehta-as-new-chief-secretary-3787574.html"
  // "https://www.knskashmir.com/jandk-govt-officially-appoints-arun-kumar-mehta-as-chief-secretary-80395",
  // "https://thetypewriter.in/dr-arun-kumar-mehta-is-new-chief-secretary-of-jk-vows-to-work-for-the-welfare-of-people/"
];

const YOUTUBE_LINKS = [
  "https://www.youtube.com/embed/p8cns-Fg5Kw?si=GpCQdFCfrp-uyvtR",
  "https://www.youtube.com/embed/9JfaalZ3VNw?si=QM_GByQKN9-puABf",
  "https://www.youtube.com/embed/G863MJGsIO4?si=bPyTprJZ-K9KzCBk",
  "https://www.youtube.com/embed/CzgXsn_siPM?si=MYxTElRd9CVYxfHh",
  "https://www.youtube.com/embed/dXtFOLokiSY?si=iMMF8LStcr-QaPgq",
  "https://www.youtube.com/embed/Qu7VK4Q3m8Q?si=ydfO2U0P-8JqiUeR",
  "https://www.youtube.com/embed/SAEt0QJPMb4?si=pb4Oe7grOb7bMfpR",
  "https://www.youtube.com/embed/AsFOVM3AQWk?si=AvYs2wzCtqW-dvfU",
  "https://www.youtube.com/embed/Ypdtr9Qb25A?si=BQocpyAdhjnaflx3",
  "https://www.youtube.com/embed/HsPOErfbQqk?si=QD0-yRtV_zZ5KglC",
  "https://www.youtube.com/embed/8S2NThl5fLs?si=knzc7Ljq_t-tga1f",
  "https://www.youtube.com/embed/W583EdIlUIE?si=FYk9r6DqJDhdai6u",
  "https://www.youtube.com/embed/spStC3N75RU?si=67tmTAchNASiJUIW",
  "https://www.youtube.com/embed/zdM1fxNDC6I?si=0JbjQcgoK6W0f08C",
  "https://www.youtube.com/embed/VPXsOCbds98?si=SewJK8CQsTdgJSWv",
  "https://www.youtube.com/embed/LOvgLP6B-zM?si=WUFLPu7pGD7KHKeU",
  "https://www.youtube.com/embed/esC936LixJc?si=pGB9C7BVSs_4kwbD",
  "https://www.youtube.com/embed/7-6LTaV6K1I?si=KGx0cIpoK1an0VMw",
  "https://www.youtube.com/embed/smXEQq4X5_U?si=fhTSlfB3o9eZ_ZPM",
  "https://www.youtube.com/embed/usqdo0LQaiA?si=KWr_hcJ3MhS0wo48",
  "https://www.youtube.com/embed/Ph3QnQ914sA?si=TeiZhWAKTavq28ai",
  "https://www.youtube.com/embed/Scnj3EwFn_Y?si=rK1whqQ7z6z1ldmb",
  "https://www.youtube.com/embed/MeFdZkl9Qxg?si=qX-rDBfFedwJK_nc",
  "https://www.youtube.com/embed/mgvZGil7BgQ?si=D1NvklTYDYVXK0xY",
  "https://www.youtube.com/embed/WVhYmptDA-4?si=SRQGzIhso2Twrfew",
  "https://www.youtube.com/embed/fmCTTEymj9w?si=8QIRa1bQZ32A00Dt",
  "https://www.youtube.com/embed/g3yc58TwKfs?si=-s6Eou5wRPd2Ga3a",
  "https://www.youtube.com/embed/tQvVoZ97LPI?si=TJYw3yaMma0vzlt0",
  "https://www.youtube.com/embed/SjVbKsZ8BWY?si=ZjrWiYwjCaJQaL8l",
  "https://www.youtube.com/embed/My8nkck4FG4?si=Ga6-oEw2PM8QLKRq"
];

/* =========================
   COMPONENT
========================= */

function PublicationsMedia() {
  return (
    <div className="App">
      {/* <br/> */}
      {/* <header className="App"> */}
        {/* <h1>Publications & Media</h1> */}
      {/* </header> */}

      <main className="App-main">
        {/* Articles / News */}
        <section className="Column">
          {NEWS_LINKS.map((url, index) => (
            <div key={index} className="news-item">
              <Microlink
                url={url}
                // size="large"
                // media="image"
                // description={false}
                lazy
                // target="_blank"
                // rel="noopener noreferrer"
                // className="microlink-card"
              />
            </div>
          ))}
        </section>

        {/* Videos */}
        <section className="Column">
          {YOUTUBE_LINKS.map((src, index) => (
            <iframe
              key={index}
              src={src}
              title={`YouTube video ${index + 1}`}
              loading="lazy"
              allowFullScreen
              style={{
                border: 'none',
                marginBottom: '20px',
                marginRight: '20px'
              }}
            />
          ))}
        </section>
      </main>

      {/* <footer className="App-footer">
        <a
          href="https://www.linkedin.com/in/arun-kumar-mehta-182175b6/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn profile"
        >
          <Linkedin />
        </a>
      </footer> */}
    </div>
  );
}

export default PublicationsMedia;
